var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "arrow-down_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#arrow-down_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "m12 12.915 4.073-4.057a.744.744 0 0 1 .514-.22.697.697 0 0 1 .54.22c.145.145.217.32.217.527a.718.718 0 0 1-.217.526l-4.048 4.049c-.294.293-.653.44-1.079.44-.426 0-.785-.147-1.079-.44L6.873 9.91a.744.744 0 0 1-.22-.514.697.697 0 0 1 .22-.54.718.718 0 0 1 .527-.217c.206 0 .382.073.527.218L12 12.915Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowDown;